export const IconAUS = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_637_1339)'>
        <path
          d='M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z'
          fill='#0052B4'
        />
        <path
          d='M11.9678 12.0004H11.9999C11.9999 11.9895 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z'
          fill='#F0F0F0'
        />
        <path
          d='M11.9997 6.26165C11.9997 4.15017 11.9997 2.76656 11.9997 0.000793457H11.9977C5.37125 0.00187158 -0.000244141 5.37398 -0.000244141 12.0007H6.26061V8.47518L9.78617 12.0007H11.9677C11.9784 11.9901 11.9891 11.9794 11.9998 11.9686C11.9998 11.1602 11.9998 10.4388 11.9998 9.78726L8.47419 6.26165H11.9997Z'
          fill='#F0F0F0'
        />
        <path
          d='M6.07112 1.56573C4.19429 2.63444 2.63401 4.19472 1.56531 6.07155V12.0005H4.69576V4.69624V4.69619H12.0001C12.0001 3.70886 12.0001 2.76827 12.0001 1.56573H6.07112Z'
          fill='#D80027'
        />
        <path
          d='M12.0004 10.5249L7.73696 6.26156H6.26129C6.26129 6.26151 6.26129 6.26156 6.26129 6.26156L12.0003 12.0006H12.0004C12.0004 12.0006 12.0004 10.9832 12.0004 10.5249Z'
          fill='#D80027'
        />
        <path
          d='M7.23753 14.0864L7.89613 15.4635L9.38333 15.1198L8.71733 16.4933L9.9133 17.4417L8.42422 17.7774L8.42839 19.3038L7.23753 18.3488L6.04672 19.3038L6.05089 17.7774L4.56177 17.4417L5.75778 16.4933L5.09169 15.1198L6.57899 15.4635L7.23753 14.0864Z'
          fill='#F0F0F0'
        />
        <path
          d='M17.9671 16.6953L18.2964 17.3839L19.04 17.212L18.7069 17.8987L19.305 18.373L18.5604 18.5408L18.5625 19.304L17.9671 18.8265L17.3717 19.304L17.3737 18.5408L16.6292 18.373L17.2272 17.8987L16.8942 17.212L17.6378 17.3839L17.9671 16.6953Z'
          fill='#F0F0F0'
        />
        <path
          d='M14.9034 9.39136L15.2326 10.08L15.9763 9.90801L15.6433 10.5948L16.2413 11.069L15.4967 11.2368L15.4988 12L14.9034 11.5225L14.308 12L14.31 11.2368L13.5655 11.069L14.1635 10.5948L13.8305 9.90801L14.5741 10.08L14.9034 9.39136Z'
          fill='#F0F0F0'
        />
        <path
          d='M17.9671 5.21759L18.2964 5.90618L19.04 5.73429L18.707 6.42106L19.3049 6.89525L18.5604 7.06311L18.5625 7.82633L17.9671 7.34881L17.3717 7.82633L17.3737 7.06311L16.6292 6.89525L17.2271 6.42106L16.8942 5.73429L17.6378 5.90618L17.9671 5.21759Z'
          fill='#F0F0F0'
        />
        <path
          d='M20.6422 8.34772L20.9714 9.03631L21.715 8.86437L21.382 9.55114L21.98 10.0254L21.2355 10.1932L21.2375 10.9564L20.6422 10.4789L20.0468 10.9564L20.0488 10.1932L19.3043 10.0254L19.9022 9.55114L19.5692 8.86437L20.3128 9.03631L20.6422 8.34772Z'
          fill='#F0F0F0'
        />
        <path
          d='M18.7292 12.0003L18.9882 12.7975H19.8264L19.1483 13.2902L19.4073 14.0873L18.7292 13.5946L18.0511 14.0873L18.3101 13.2902L17.632 12.7975H18.4702L18.7292 12.0003Z'
          fill='#F0F0F0'
        />
      </g>
      <defs>
        <clipPath id='clip0_637_1339'>
          <rect width='24' height='24' fill='white' transform='translate(0.5 0.00012207)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconUSA = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_637_2791)'>
        <g clipPath='url(#clip1_637_2791)'>
          <path
            d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
            fill='#F0F0F0'
          />
          <path d='M11.4783 12H24C24 10.9169 23.8556 9.86768 23.5866 8.86957H11.4783V12Z' fill='#D80027' />
          <path
            d='M11.4783 5.73916H22.2387C21.5041 4.54047 20.5649 3.48095 19.4698 2.6087H11.4783V5.73916Z'
            fill='#D80027'
          />
          <path
            d='M12 24C14.8242 24 17.42 23.0239 19.4698 21.3914H4.53018C6.58003 23.0239 9.17582 24 12 24Z'
            fill='#D80027'
          />
          <path
            d='M1.76128 18.2609H22.2387C22.8285 17.2986 23.2858 16.2467 23.5866 15.1304H0.413391C0.714188 16.2467 1.17155 17.2986 1.76128 18.2609Z'
            fill='#D80027'
          />
          <path
            d='M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z'
            fill='#0052B4'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_637_2791'>
          <rect width='24' height='24' fill='white' transform='translate(0.5 0.00012207)' />
        </clipPath>
        <clipPath id='clip1_637_2791'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
